import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class MountainLake3PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.MOUNTAIN_LAKE3;
}

export default MountainLake3PoiTileEntity;
